import { has } from 'lodash';
// @ts-ignore
import * as shuffleSeed from 'shuffle-seed';

export function isAdvert(input: any): input is AdvertFragment {
  return has(input, 'buttonPlacement');
}

export function injectAdverts<TList, TAdvert>(list: Array<TList>, collection?: Pick<AdvertCollectionFragment, 'repetitions' | 'positioning' | 'frequency'> & { collection?: Array<TAdvert> }): Array<TList | TAdvert> {
  if (!collection || !collection.collection) {
    return list;
  }
  // Seed for the shuffle adverts are random but constant.
  const seed = 'f939d095bb4292bd0c60dad87be7b6db';

  const output: Array<TList | TAdvert> = [];
  let placedAdverts = 0;
  let advertQueue = collection.positioning === 'random' ? shuffleSeed.shuffle(collection.collection, seed) : [...collection.collection];

  list.forEach((item, index) => {
    if ((index + 1) % collection.frequency === 0) {
      if (advertQueue.length === 0 && collection.repetitions === 'repeat') {
        advertQueue = collection.positioning === 'random' ? shuffleSeed.shuffle(collection.collection, seed) : [...collection.collection!];
      }
      const advert = advertQueue.shift();

      if (advert) {
        // If we should put the advert before or after 4th item.
        if ((placedAdverts * 2 + index + 1) % 4 === 0) {
          output.push(item, advert);
        } else {
          output.push(advert, item);
        }
        placedAdverts++;
      } else {
        output.push(item);
      }
    } else {
      output.push(item);
    }
  });

  return output;
}
